import { createTokenService } from '@alycecom/services';
import { useLocation } from 'react-use';

import { BRANDING_INFO } from '../constants/cookies.constants';
import { BRANDING_TOKEN_TYPE } from '../modules/BrandingModule/constants/branding.constants';
import { getGiftHashFromUrl } from '../helpers/url.helpers';

/* Disable a rule because of this data from the token. */
/* eslint-disable camelcase */
interface IBrandingPayload {
  branding_hash: string;
  branding_owner_name?: string;
}
/* eslint-enable camelcase */

const brandingTokenService = createTokenService<IBrandingPayload>({
  tokenName: BRANDING_INFO,
  minTimeToExpire: 150,
});

export const useCheckBrandingToken = (): boolean => {
  const { pathname = '' } = useLocation();
  const hash = getGiftHashFromUrl(pathname);
  const isExpired = brandingTokenService.isExpired();
  const decodedToken = brandingTokenService.getDecodedToken();
  const { type, isValid } = decodedToken;

  return isValid && !isExpired && type === BRANDING_TOKEN_TYPE && hash === decodedToken.branding_hash;
};

export const useGetBrandingOwnerName = (): string => {
  const decodedToken = brandingTokenService.getDecodedToken();
  const { branding_owner_name: name } = decodedToken;
  return name || '';
};
